"use client";

import { MegaMenu } from "./mega-menu";
import { PeptidesPanel, ResearchPanel, SupportPanel } from "./mega-menu-panels";
import type {
	CategoryItem,
	FeaturedProduct,
	PeptidesPanelLabels,
	ResearchPanelLabels,
	SupportPanelLabels,
} from "./mega-menu-panels";

type PanelId = "peptides" | "research" | "support";

interface MegaMenuWithPanelsProps {
	triggers: { id: PanelId; label: string }[];
	categories: CategoryItem[];
	peptidesLabels: PeptidesPanelLabels;
	researchLabels: ResearchPanelLabels;
	supportLabels: SupportPanelLabels;
	featured?: FeaturedProduct | null;
	focusProduct?: FeaturedProduct | null;
}

export function MegaMenuWithPanels({
	triggers,
	categories,
	peptidesLabels,
	researchLabels,
	supportLabels,
	featured = null,
	focusProduct = null,
}: MegaMenuWithPanelsProps) {
	return (
		<MegaMenu triggers={triggers}>
			{(activePanel) => (
				<>
					{activePanel === "peptides" && (
						<PeptidesPanel categories={categories} featured={featured} labels={peptidesLabels} />
					)}
					{activePanel === "research" && (
						<ResearchPanel labels={researchLabels} focusProduct={focusProduct} />
					)}
					{activePanel === "support" && <SupportPanel labels={supportLabels} />}
				</>
			)}
		</MegaMenu>
	);
}
